import { getEmissionsUnit } from '@/utils/pathwayTemplateUtils';
import { parseLCAData } from '@/utils/analysisUtils';
import WaterfallChart from '../charts/WaterfallChart';
import { useLcaData } from '@/stores/pathwayTemplateAnalysisStore';
import LcaControl from '@/components/pathwayNavigator/LcaControl';
import LoadingSkeleton from '../core/LoadingSkeleton';

const EmissionsChart = () => {
  const { data, loading, error } = useLcaData();

  if (loading && !data) return <LoadingSkeleton />;
  if (error) return <div>Error: {error.message}</div>;

  const unit = getEmissionsUnit(data);
  const result = parseLCAData(data);

  return (
    <>
      <WaterfallChart data={result} label="" yAxisLabel={`Emissions\n[${unit}]`} />
      <LcaControl />
    </>
  );
};

export default EmissionsChart;
